import { RESET_REMARKS, RemarksActionTypes, SET_REMARKS } from './remarksActionTypes';

export const setRemarksAction = (payload: string): RemarksActionTypes => ({
	type: SET_REMARKS,
	payload,
});

export const resetRemarks = (): RemarksActionTypes => ({ type: RESET_REMARKS });
